import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.scss';
// Import des icônes de Font Awesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faYoutube, 
  faTiktok, 
  faTwitch, 
  // faTwitter, 
  // faInstagram 
} from '@fortawesome/free-brands-svg-icons';

function Footer() {

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-info">
          <h3>À propos</h3>
          <p>Création d'emotes personnalisées pour vos streams et serveurs Discord. Un style unique pour votre communauté.</p>
        </div>

        <div className="footer-links">
          <h3>Liens Rapides</h3>
          <ul>
            <li><Link to="/gallery" onClick={scrollToTop}>Galerie</Link></li>
            <li><Link to="/prices" onClick={scrollToTop}>Tarifs</Link></li>
            <li><Link to="/commission" onClick={scrollToTop}>Commander</Link></li>
            <li><Link to="/contact" onClick={scrollToTop}>Contact</Link></li>
            <li><Link to="/legal" onClick={scrollToTop}>Mentions légales</Link></li>
          </ul>
        </div>

        <div className="footer-social">
          <h3>Suivez-moi</h3>
          <div className="social-icons">
            <a href="https://www.youtube.com/@juudcoco" className="youtube" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faYoutube} />
            </a>
            <a href="https://www.tiktok.com/@juudcoco" className="tiktok" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTiktok} />
            </a>
            <a href="https://www.twitch.tv/judcoco" className="twitch" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitch} />
            </a>
            {/* <a href="https://twitter.com/votre-compte" className="twitter" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faTwitter} />
            </a>
            <a href="https://instagram.com/votre-compte" className="instagram" target="_blank" rel="noopener noreferrer">
              <FontAwesomeIcon icon={faInstagram} />
            </a> */}
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} Judcoco. Tous droits réservés.</p>
      </div>
    </footer>
  );
}

export default Footer;